import { render, staticRenderFns } from "./systemMsg.vue?vue&type=template&id=532fe951&scoped=true&"
import script from "./systemMsg.vue?vue&type=script&lang=js&"
export * from "./systemMsg.vue?vue&type=script&lang=js&"
import style0 from "./systemMsg.vue?vue&type=style&index=0&id=532fe951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532fe951",
  null
  
)

export default component.exports